"use client";

import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils"

interface MobileShareButtonPraiseProps extends React.HTMLAttributes<HTMLButtonElement> {
    url: string;
}

export function MobileShareButtonPraise({ title, url, ...props}: MobileShareButtonPraiseProps) {
  const handleShare = async () => {
    console.log('share button clicked')
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'You are amazing!',
          text: `I wrote a little something for you...`,
          url: url,
        });
      } catch (error) {
        console.error('Error sharing:', error);
      }
    } else {
      // fallback for browsers that don't support the Web Share API
      console.log('Web Share API not supported');
    }
  };

  return (
    <button className={cn(buttonVariants(), "my-2 bg-blue-500 w-full")} onClick={handleShare}>
        <p>{title}</p>
    </button>
  );
};